export interface LogPayload {
  origin: string;
  message: string;
  extra?: unknown;
}

class ClientLogger {
  public info(payload: LogPayload) {
    fetch("/api/post-log/info/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...payload,
      }),
    }).catch((error) => {
      console.error("Failed to log info:", error);
    });
  }

  public warn(payload: LogPayload) {
    fetch("/api/post-log/warn/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...payload,
      }),
    }).catch((error) => {
      console.error("Failed to log warning:", error);
    });
  }

  public error(payload: LogPayload) {
    fetch("/api/post-log/error/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...payload,
      }),
    }).catch((error) => {
      console.error("Failed to log error:", error);
    });
  }
}

const clientLogger = new ClientLogger();

export default clientLogger;
